/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CustomsDelayNotificationEmailDefaultContent
 */
export interface CustomsDelayNotificationEmailDefaultContent {
  /**
   *
   * @type {string}
   * @memberof CustomsDelayNotificationEmailDefaultContent
   */
  subject: string;
  /**
   *
   * @type {string}
   * @memberof CustomsDelayNotificationEmailDefaultContent
   */
  body: string;
  /**
   *
   * @type {Array<string>}
   * @memberof CustomsDelayNotificationEmailDefaultContent
   */
  recipients: Array<string>;
  /**
   *
   * @type {string}
   * @memberof CustomsDelayNotificationEmailDefaultContent
   */
  brokerEmail?: string | null;
}

/**
 * Check if a given object implements the CustomsDelayNotificationEmailDefaultContent interface.
 */
export function instanceOfCustomsDelayNotificationEmailDefaultContent(
  value: object,
): value is CustomsDelayNotificationEmailDefaultContent {
  if (!("subject" in value) || value["subject"] === undefined) return false;
  if (!("body" in value) || value["body"] === undefined) return false;
  if (!("recipients" in value) || value["recipients"] === undefined)
    return false;
  return true;
}

export function CustomsDelayNotificationEmailDefaultContentFromJSON(
  json: any,
): CustomsDelayNotificationEmailDefaultContent {
  return CustomsDelayNotificationEmailDefaultContentFromJSONTyped(json, false);
}

export function CustomsDelayNotificationEmailDefaultContentFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CustomsDelayNotificationEmailDefaultContent {
  if (json == null) {
    return json;
  }
  return {
    subject: json["subject"],
    body: json["body"],
    recipients: json["recipients"],
    brokerEmail: json["brokerEmail"] == null ? undefined : json["brokerEmail"],
  };
}

export function CustomsDelayNotificationEmailDefaultContentToJSON(
  json: any,
): CustomsDelayNotificationEmailDefaultContent {
  return CustomsDelayNotificationEmailDefaultContentToJSONTyped(json, false);
}

export function CustomsDelayNotificationEmailDefaultContentToJSONTyped(
  value?: CustomsDelayNotificationEmailDefaultContent | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    subject: value["subject"],
    body: value["body"],
    recipients: value["recipients"],
    brokerEmail: value["brokerEmail"],
  };
}
